import { render, staticRenderFns } from "./PreviewDetails.vue?vue&type=template&id=6f9fccd5&"
import script from "./PreviewDetails.vue?vue&type=script&lang=js&"
export * from "./PreviewDetails.vue?vue&type=script&lang=js&"
import style0 from "./PreviewDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports